export default __webpack_public_path__ + "static/media/COSM376.f7c555ce.mp3";